import React, { lazy } from 'react';
import { ZapIcon } from 'lucide-react';
export function AboutSection() {
  return <section className="bg-cream py-10 px-4" data-id="element-27">
      <div className="max-w-[600px] mx-auto text-center" data-id="element-28">
        {/* Circular Photo */}
        <div className="mx-auto mb-6 w-40 h-40 rounded-full overflow-hidden border-4 border-primary shadow-[0_0_20px_rgba(59,130,246,0.3)]" data-id="element-29">
          <img loading="lazy" src="https://cdn.magicpatterns.com/uploads/iXnEaMwHhCvmTdcx9j2hdf/ChatGPT_Image_Mar_24,_2026,_11_55_18_AM.webp" alt="Ing. Carlos Mendoza" className="w-full h-full object-cover" width="160" height="160" data-id="element-30" />
        </div>

        {/* Name */}
        <h2 className="text-[24px] font-bold text-brand-black mb-1 flex items-center justify-center gap-2" data-id="element-31">
          <ZapIcon className="w-5 h-5 text-primary" data-id="element-32" />
          Acerca del Ing. Carlos Mendoza
        </h2>
        <div className="w-16 h-1 bg-primary mx-auto rounded-full mb-6" data-id="element-33"></div>

        {/* Bio */}
        <div className="bg-brand-black-light border border-white/10 rounded-xl p-6 shadow-soft text-left" data-id="element-34">
          <p className="text-brand-black text-base leading-relaxed mb-4" data-id="element-35">
            Soy Carlos Mendoza, electricista con más de{' '}
            <span className="text-primary font-bold" data-id="element-36">
              15 años de experiencia
            </span>
            .
          </p>
          <p className="text-dark-gray text-base leading-relaxed mb-4" data-id="element-37">
            Cuando entendí realmente los comandos eléctricos, pasé de hacer
            trabajos básicos… a generar más de{' '}
            <span className="text-primary font-bold" data-id="element-38">$1,000 a la semana</span>{' '}
            como contratista.
          </p>
          <p className="text-brand-black text-base leading-relaxed font-medium" data-id="element-39">
            Por eso creé este sistema: para que tú también puedas llegar a ese
            nivel sin importar tu experiencia o tus estudios.
          </p>
        </div>
      </div>
    </section>;
}